import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoArrowBack } from "react-icons/io5";

const ProductDetail = ({ addtocart }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const product = location.state; // product data passed from Home.js

  const [country, setCountry] = useState("US");
  const [currency, setCurrency] = useState("USD");
  const [exchangeRateLoaded, setExchangeRateLoaded] = useState(false);

  // Fetch user's country
  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();
        setCountry(data.country_code || "US");
      } catch (err) {
        console.error("Location error:", err);
        setCountry("US");
      } finally {
        setExchangeRateLoaded(true);
      }
    };
    fetchCountry();
  }, []);

  // Currency logic (all prices stored in Naira)
  const getDisplayedPrice = (price) => {
    const basePrice = Number(price);

    // Nigerians see Naira prices directly
    if (country === "NG") {
      return `₦${basePrice.toLocaleString()}`;
    }

    // Others see converted USD equivalent
    const usdRate = 1437; // NGN/USD approximate
    const converted = basePrice / usdRate;

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      maximumFractionDigits: 2,
    }).format(converted);
  };

  if (!product) {
    return (
      <div className='product-detail'>
        <div className='container'>
          <h2>Product not found</h2>
          <button onClick={() => navigate(-1)}>Go Back</button>
        </div>
      </div>
    );
  }

  return (
    <div className='product-detail'>
      <div className='container'>
        <div className='back-btn' onClick={() => navigate(-1)}>
          <IoArrowBack size={22} />
          <span>Back</span>
        </div>

        <div className='product-box'>
          <div className='img-box'>
            <img
              src={`/${product.image}`}
              alt={product.Name}
              style={{ width: "100%", maxWidth: "400px", objectFit: "cover", borderRadius: "10px" }}
            />
          </div>

          <div className='info-box'>
            <h2>{product.Name}</h2>
            <p className='desc'>
              {product.description || 'This product is a premium addition to your wardrobe, blending comfort and style seamlessly.'}
            </p>

            <h3 className='price'>
              {exchangeRateLoaded ? getDisplayedPrice(product.price) : "Loading..."}
            </h3>

            <div className='actions'>
              <button className='btn' onClick={() => addtocart(product)}>
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .product-detail {
          padding: 50px 0;
          display: flex;
          justify-content: center;
          background-color: #fff;
        }
        .container {
          width: 90%;
          max-width: 1100px;
        }
        .back-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          cursor: pointer;
          margin-bottom: 20px;
        }
        .product-box {
          display: flex;
          flex-wrap: wrap;
          gap: 30px;
        }
        .img-box img {
          width: 380px;
          border-radius: 10px;
          object-fit: cover;
        }
        .info-box {
          flex: 1;
          min-width: 300px;
        }
        .info-box h2 {
          font-size: 1.8rem;
          margin-bottom: 10px;
        }
        .info-box .price {
          font-size: 1.4rem;
          margin: 15px 0;
          color: #333;
        }
        .btn {
          background-color: black;
          color: white;
          padding: 12px 25px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: 0.3s;
        }
        .btn:hover {
          background-color: #333;
        }
      `}</style>
    </div>
  );
};

export default ProductDetail;
